import { render, staticRenderFns } from "./OrdersListButton.vue?vue&type=template&id=08e9a6f1&"
import script from "./OrdersListButton.vue?vue&type=script&lang=js&"
export * from "./OrdersListButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrdersListButton.vue"
export default component.exports